import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import useUploadContext from '../../../../../../hooks/useUploadContext/useUploadContext';
import { timeRemain } from './Remain';

interface TimerProps {
  fileDate: string;
  timeExpired: Function;
}

function Timer(props: TimerProps) {
  const [time, setTime] = useState({ hours: '00', minutes: '00', seconds: '00' });
  const [isEnoughTime, setIsEnoughTime] = useState(true);
  const { fileDate, timeExpired } = props;
  const { setIsExpiredTime, isExpiredTime } = useUploadContext();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsExpiredTime(true);
      let expire = timeRemain(fileDate);

      let hours = expire.hours;
      let minutes = expire.minutes;
      let seconds = expire.seconds;

      if (hours === 0 && minutes === 0 && seconds === 0) {
        timeExpired();
        clearInterval(intervalId);
      }
      if (hours > 2) {
        setIsEnoughTime(true);
      } else {
        setIsEnoughTime(false);
      }
      setTime({
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0'),
      });
      setIsExpiredTime(false);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [fileDate]);

  return !isExpiredTime ? (
    <Typography
      className={`${isEnoughTime ? 'expiration-enough' : 'expiration-not-enough'} expiration`}
    >{`${time.hours}:${time.minutes}:${time.seconds}`}</Typography>
  ) : null;
}

export default Timer;
